<template>
  <v-col cols="12">
    <p>Payments</p>
    <v-card elevation="0" outlined>
      <v-card-text
        class="d-flex sm-align-center justify-space-between pb-2"
        :class="{ 'flex-column': $vuetify.breakpoint.xs }"
      >
        <div>
          <h4 class="dark--text font-weight-medium fz-16">Current balance</h4>
          <p :class="{'mb-0':$vuetify.breakpoint.smAndUp }">${{ balance }}</p>
        </div>
        <v-btn
          color="primary"
          elevation="0"
          @click="addCredit = true"
          :block="$vuetify.breakpoint.xs"
          :outlined="$vuetify.breakpoint.smAndUp"
          >Add Credit
        </v-btn>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-text class="d-flex justify-space-between py-6">
        <h4 class="dark--text font-weight-medium fz-16">Billing history</h4>
        <v-btn
          small
          icon
          to="/billing-history"
        >
        <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </v-card-text>
      <v-divider></v-divider>
      <v-layout
        justify-space-between
        class="sm-align-center pa-4"
        :class="{ 'flex-column': $vuetify.breakpoint.xs }"
      >
        <div>
          <p class="body-1 mb-0 font-weight-medium fz-16">Auto-recharge</p>
          <p  :class="{'mb-0':$vuetify.breakpoint.smAndUp}" class="caption">When balance falls below $2.00</p>
        </div>
        <v-spacer></v-spacer>
        <v-select
          v-model="autoRecharge"
          :items="items"
          :menu-props="{ contentClass: 'settings-select' }"
          item-text="text"
          item-value="value"
          attach
          dense
          class="autoRechargeSelect"
          outlined
          hide-details
          width="50"
        >
          <template v-slot:selection="{ item }">
            <span>
              {{ item.value && item.value !== 'email' ? 'On' : item.text }}
            </span>
          </template>
          <template v-slot:item="{ item }">
            <v-icon class="me-3 ms-1">{{ item.icon }}</v-icon>
            {{ item.text }}
          </template>
        </v-select>
        <div class="select-bg"></div>
      </v-layout>
      <v-divider></v-divider>
      <v-card-text class="d-flex align-center justify-space-between">
        <div>
          <h4 class="dark--text font-weight-medium fz-16">Calling rates</h4>
          <v-subheader class="px-0"
            >Look up calling rates by country</v-subheader
          >
        </div>
        <v-btn icon elevation="0" @click="$router.push({ name: 'CallingRates' })">
          <v-icon>mdi-open-in-new</v-icon>
        </v-btn>
      </v-card-text>
    </v-card>

    <!-- Add Credit Dialog-->
    <v-dialog v-model="addCredit" width="600">
      <v-card max-height="276px">
        <v-card-title class="body-1">
          Add credit
          <v-spacer></v-spacer>
          <v-btn @click="addCredit = false" small icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="fz-12 pb-0">
          Use credit to make paid calls with {{ profileData && profileData.company_domain ? profileData.company_domain : 'FreeFone' }} Voice.
<!--           <a href="#" class="text-decoration-none info--text">Learn more</a>. -->
        </v-card-text>

        <div class="px-8">
          <v-radio-group v-model="creditAmount" row>
            <v-radio label="$10.00" value="10"></v-radio>
            <v-radio label="$25.00" value="25"></v-radio>
            <v-radio label="$50.00" value="50"></v-radio>
          </v-radio-group>
        </div>
        <!-- <v-card-text v-if="userProfile.balance" class="fz-12 pb-0">
          Your current balance is $ {{ userProfile.balance }}. The account balance cannot exceed
          $70.00.
        </v-card-text> -->

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            small
            color="primary"
            class="px-5 py-5"
            elevation="0"
            outlined
            @click="addCredit = false"
            >Cancel
          </v-btn>
          <v-btn
            :disabled="!creditAmount"
            small
            color="primary"
            class="px-5 py-5"
            elevation="0"
            @click="creditStore"
            >Add credit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Payment Dialog-->
    <v-dialog v-model="paymentDialog" width="800">
      <v-card max-height="80vh" class="choose-payment-method">
        <v-card-title class="body-1">
          Choose Payment Method
          <v-spacer></v-spacer>
          <v-btn @click="paymentDialog = false" small icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="fz-18 px-8 d-flex align-center">
          <img src="@/assets/logo.svg" style="width: 30px; margin-right: 10px;"> Auto-recharge calling credit
        </v-card-text>

        <div class="px-8">
          Select payment method
          <v-radio-group v-model="paymentMethod" row>
            <template v-if="paymentCards.length">
              <v-radio v-for="item in paymentCards" :key="item.id" label="$10.00" value="10"></v-radio>
            </template>
            <v-radio label="Add credit or debit card" value="add"></v-radio>
          </v-radio-group>
        </div>
        <div v-if="paymentMethod === 'add'" class="px-8">
          <v-row>
            <v-col
              cols="12"
              lg="12"
              md="12"
            >
              <label class="fz-14 mb-1 d-block">Card number</label>
              <v-text-field
                v-model="cardNumber"
                :rules="cardRules"
                :maxlength="19"
                solo
                outlined
                label="Card number"
                type="card"
                dense
                hide-details
                @keypress="onlyNumbers"
              ></v-text-field>
            </v-col>
            <v-col
              cols="8"
              class="pr-2"
            >
              <label class="fz-14 mb-1 d-block">Expiration date</label>
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                ref="menu"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="expirationDate"
                    solo
                    outlined
                    dense
                    hide-details
                    label="Expiration date"
                    type="text"
                    class="pt-0"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="expirationDatePicker"
                  :min="today"
                  type="month"
                  no-title
                  scrollable
                  ></v-date-picker>
                  <!-- @input="$refs.menu.save(form.expirationDate)" -->
              </v-menu>
            </v-col>
            <v-col
              cols="4"
              style="padding-right:17px"
            >
              <label class="fz-14 mb-1 d-block">CVV</label>
              <v-text-field
                v-model="addCardForm.cvc"
                :rules="cvvRules"
                :maxlength="3"
                solo
                outlined
                label="CVV"
                type="text"
                dense
                hide-details
                @keypress="onlyNumbers"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
            >
              <label class="fz-14 mb-1 d-block">Address 1</label>
              <v-text-field
                v-model="addCardForm.billing_address_1"
                :rules="addressRules"
                solo
                outlined
                label="Address 2"
                type="text"
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
            >
              <label class="fz-14 mb-1 d-block">Address 2</label>
              <v-text-field
                v-model="addCardForm.billing_address_2"
                :rules="addressRules"
                solo
                outlined
                label="Address 2"
                type="text"
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
            >
              <label class="fz-14 mb-1 d-block">City</label>
              <v-text-field
                v-model="addCardForm.city"
                :rules="cityRules"
                :maxlength="24"
                solo
                outlined
                label="City"
                type="text"
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
            >
              <label class="fz-14 mb-1 d-block">State</label>
              <v-text-field
                v-model="addCardForm.state"
                solo
                outlined
                label="State"
                type="text"
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              style="padding-right:17px"
            >
              <label class="fz-14 mb-1 d-block">ZIP code</label>
              <v-text-field
                v-model="addCardForm.zip_code"
                :rules="zipRules"
                :maxlength="5"
                solo
                outlined
                label="ZIP code"
                type="text"
                dense
                hide-details
                @keypress="onlyNumbers"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
            >
              <label class="fz-14 mb-1 d-block">Address 1</label>
              <v-text-field
                v-model="addCardForm.firstName"
                :rules="firstNameRules"
                solo
                outlined
                label="First Name"
                type="text"
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
            >
              <label class="fz-14 mb-1 d-block">Address 2</label>
              <v-text-field
                v-model="addCardForm.lastName"
                :rules="lastNameRules"
                solo
                outlined
                label="Last Name"
                type="text"
                dense
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </div>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            small
            color="primary"
            class="px-5 py-5"
            elevation="0"
            outlined
            @click="paymentDialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            :disabled="!creditAmount"
            small
            color="primary"
            class="px-5 py-5"
            elevation="0"
            @click="addCard"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-col>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'

export default {
  name: 'settingsPayments',
  props: ['profileData'],
  data: () => {
    return {
      profile: {},
      addCredit: false,
      creditAmount: '10',
      showBillingHistory: false,
      autoRecharge: null,
      paymentDialog: false,
      paymentMethod: null,
      paymentCards: [],
      addCardForm: {
        number: '',
        cvc: '',
        exp_month: null,
        exp_year: null,
        billing_address_1: '',
        billing_address_2: '',
        state: '',
        city: '',
        zip_code: '',
        firstName: '',
        lastName: ''
      },
      menu: false,
      cardRules: [
        v => !!v || 'Card number is required',
        v => /^(?:4[0-9]{12}(?:[0-9]{3})?|[25][1-7][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/.test((v.replace(/\s+/g, ''))) || 'Card number must be valid'
      ],
      dateRules: [
        v => !!v || 'Date is required',
        v => /^[0-9]+-[0-9]+$/.test(v) || 'Date must be valid'
      ],
      cvvRules: [
        v => !!v || 'CVV is required',
        v => (/^[0-9]+$/.test(v) && v.length <= 3) || 'CVV must be valid'
      ],
      firstNameRules: [
        v => !!v || 'First Name is required'
      ],
      lastNameRules: [
        v => !!v || 'Last Name is required'
      ],
      addressRules: [
        v => !!v || 'Address is required'
      ],
      cityRules: [
        v => !!v || 'City is required'
      ],
      stateRules: [
        v => !!v || 'State is required'
      ],
      zipRules: [
        v => !!v || 'ZIP code is required'
      ],
      items: [
        {
          text: 'Off',
          value: '',
          icon: 'mdi-bell-off'
        },
        {
          text: '10.00',
          value: '10',
          icon: 'mdi-currency-usd'
        },
        {
          text: '25.00',
          value: '25',
          icon: 'mdi-currency-usd'
        },
        {
          text: '50.00',
          value: '50',
          icon: 'mdi-currency-usd'
        },
        {
          text: 'Notify me via email',
          value: 'email',
          icon: 'mdi-email-alert'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['userProfile']),
    balance () {
      return this.profile.balance ? this.profile.balance.toFixed(2) : 0
    },
    expirationDate: {
      get () {
        if (!this.addCardForm.exp_month || !this.addCardForm.exp_year) return ''
        return `${this.addCardForm.exp_month < 10 ? `0${this.addCardForm.exp_month}` : this.addCardForm.exp_month}/${this.addCardForm.exp_year}`
      }
    },
    expirationDatePicker: {
      get () {
        if (!this.expirationDate) return ''
        const [m, y] = this.expirationDate.split('/')
        return `${y}-${m}`
      },
      set (val) {
        const [y, m] = val.split('-')
        this.addCardForm.exp_year = parseInt(y)
        this.addCardForm.exp_month = parseInt(m)
      }
    },
    cardNumber: {
      get () {
        try {
          const cleaned = `${this.addCardForm.number}`
          const match = cleaned.match(/.{1,4}/g)
          return match.join(' ')
        } catch (err) {
          return this.addCardForm.number
        }
      },
      set (e) {
        this.addCardForm.number = e.replace(/\D/g, '')
      }
    },
    currentYear () {
      const dateobj = new Date()
      return dateobj.getFullYear()
    },
    currentMonth () {
      const dateobj = new Date()
      return parseInt(dateobj.getMonth()) + 1
    },
    today () {
      return moment(new Date()).format('YYYY-MM-DD')
    }
  },
  methods: {
    ...mapActions([
      'editUserProfile',
      'createPayment',
      'setLowBalanceEmail',
      'autoChargeCredits',
      'getAutoChargeCards',
      'postAutoChargeCards'
    ]),
    async profileUpdate(key, value) {
      try {
        await this.editUserProfile({ [key]: value })
      } catch (err) {
        throw new Error(err)
      }
    },
    async creditStore() {
      try {
        const data = await this.createPayment({ amount: +this.creditAmount })
        if (data.payment_url) {
          this.addCredit = false
          window.location.href = data.payment_url
          return
        }
        window.scrollTo(0, 101)
      } catch (err) {
        throw new Error(err)
      }
    },
    async loadCards () {
      try {
        const data = await this.getAutoChargeCards()
        if (!data || !data.data) return

        this.paymentCards = data.data
      } catch (err) {
        console.log('API: ', (err?.message || err))
      }
    },
    async addCard() {
      try {
        if (this.paymentMethod === 'add') {
          const data = await this.postAutoChargeCards(this.addCardForm)
          if (!data) return
        }
        this.toggleBalanceEmail(this.autoRecharge)
        if (this.autoRecharge !== 'email') this.toggleAutoCharge(this.autoRecharge)
      } catch (err) {
        throw new Error(err)
      }
    },
    async toggleBalanceEmail(val) {
      try {
        const data = await this.setLowBalanceEmail(val === 'email')
        if (!data) return
      } catch (err) {
        throw new Error(err)
      }
    },
    async toggleAutoCharge(val) {
      try {
        const data = await this.autoChargeCredits({ enable: !!val, threshole: +val })
        if (!data) return
      } catch (err) {
        throw new Error(err)
      }
    }
  },
  watch: {
    profileData() {
      this.profile = this.profileData
      this.autoRecharge = this.profileData.low_balance_email ? 'email' : this.profileData.credit_auto_charge ? `${this.profileData.credit_threshole}` : ''
    },
    autoRecharge (newVal, oldVal) {
      if (oldVal === null) return
      this.loadCards()
      this.paymentDialog = true
    }
  }
}
</script>

<style scoped>
.autoRechargeSelect{
  max-width: fit-content;
}

.v-btn {
  text-transform: none;
}

.font-weight-normal {
  font-weight: 400 !important;
}

.icon-wrapper {
  background-color: rgba(127, 165, 232, 0.2);
  width: 40px;
  height: 40px;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.v-list-item__subtitle {
  white-space: normal !important;
}

@media (max-width: 575.98px) {
  .autoRechargeSelect {
    max-width: 100%;
  }
}
</style>
<style lang="scss" scoped>
  .autoRechargeSelect .v-menu__content {
    min-width: 190px !important;
    position: absolute;
    display: inline-block;
    max-width: 80%;
    overflow-y: auto;
    overflow-x: hidden;
    contain: content;
    box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    height: 104px;
    top: 0px !important;
    left: 0px !important;
    margin-left: -29px !important;
    margin-top: 40px !important;
  }
  .choose-payment-method {
    overflow-y: auto;
  }
</style>
